/**
 * Authentication Actions
 */
export const LOGIN = "login";
export const GET_USER = "getUser";
export const SWITCH_ROLE = 'switchRole';
export const SWITCH_COMMITTEE = 'switchCommittee';
export const REGISTRATION = "registration";
export const SET_LOADING = "setLoading";
export const LOGOUT = "logout";
export const SEND_CODE = "sendCode";
export const SEND_CODE_ON_EMAIL = "send2faCodeOnEmail";
export const VERIFY_CODE = "verifyCode";
export const UPDATE_PROFILE = "udpateProfile";
export const UPDATE_PASSWORD = "updatePassword";
export const MANAGE_REMIND = "donotremind";
export const SEND_2FA_SETUP_CODE = "send2fasetupcode";
export const SET_PASSWORD = 'setPassword';
export const REQUEST_RESET_PASSWORD_EMAIL = 'requestResetPwdEmail';
/**
 * System Admin Actions
 */
export const GET_USER_REQUEST = "getUserRequest";
export const GET_ALL_USERS = "getAllUsers";
export const GET_ALL_CM = "getAllCM";
export const GET_USER_INFO = "getUserInfo";
export const ACTIVATE_USER = "activateUser";
export const DEACTIVATE_USER = "deactivateUser";
export const DELETE_USER = "deleteUser";
export const APPROVE_USER_REQUEST = "approveUserRequest";
export const REJECT_USER_REQUEST = "rejectUserRequest";
export const UPDATE_REGISTRATION_REQUEST = "updateRegistrationRequest";
export const UPDATE_USER_DETAIL = "updateUserDetail";
export const GET_PAST_NOTIFICATION = "getPastNotification";
export const SEND_NOTIFICATION = "sendNotification";
export const UPDATE_COMMITTEE_ADMIN = "updateCommitteeAdmin";
export const UPDATE_COMMITTEE_PERMISSIONS = "updateCommitteePermissions";
/**
 * Facilities , Sites, Jobs, Invoices Actions
 */
export const GET_FACILITIES = "facilities";
export const GET_FACILITY = "facility";
export const UPDATE_FACILITY = "updateFacility";
export const GET_FACILITY_INFO = 'getFacilityInfo';
export const GET_FACILITY_DOCUMENTS = "getFacilityDocuments";
export const UPLOAD_FACILITY_DOCUMENT = "uploadFacilityDocument";
export const PREVIEW_FACILITY_DOCUMENT = "previewFacilityDocument";
export const DOWNLOAD_FACILITY_DOCUMENT = "downloadFacilityDocument";
export const DOWNLOAD_FACILITY_DOCUMENTS = "downloadFacilityDocuments";

export const GET_SITE = "site";
export const GET_SITE_DOCUMENTS = "getSiteDocuments";
export const UPLOAD_SITE_DOCUMENT = "uploadSiteDocument";
export const PREVIEW_SITE_DOCUMENT = "previewSiteDocument";
export const DOWNLOAD_SITE_DOCUMENT = "downloadSiteDocument";
export const DOWNLOAD_SITE_DOCUMENTS = "downloadSiteDocuments";

export const UPDATE_SITE = "updateSite";
export const POST_SITE_DOC = "post_site_document";

export const GET_JOB = "job";
export const GET_JOB_LA = "getJobLA";
export const GET_USER_JOBS = "getUserJobs";
export const GET_JOB_DOCUMENTS = "jobDocuments";
export const UPLOAD_JOB_DOCUMENT = "uploadJobDocument";
export const DOWNLOAD_JOB_DOCUMENT = "downloadJobDocument";
export const DOWNLOAD_JOB_DOCUMENTS = "downloadJobDocuments";
export const PREVIEW_JOB_DOCUMENT = "previewJobDocument";
export const REVIEW_JOB_DOCUMENT = "reviewJobDocument";

export const GET_INVOICES = "invoices";

/**
 * Forums actions
 */
export const GET_FORUM_CATEGORIES = "getForumCategories";
export const LOAD_FORUM_CATEGORIES = "loadForumCategories";
export const GET_FORUM_THREADS = "getForums";
export const LOAD_FORUM_THREADS = "loadForums";
export const GET_THREAD_DETAILS = "threadDetails";
export const CREATE_FORUM_THREAD = "createForumThread";
export const EDIT_FORUM_THREAD = "editForumThread";
export const DELETE_FORUM_THREAD = "deleteForumThread";
export const CREATE_FORUM_REPLY = "createForumReply";
export const EDIT_FORUM_REPLY = "editForumReply";
export const DELETE_FORUM_REPLY = "deleteForumReply";
export const GET_FORUM_DOCUMENT = "downloadForumDocument";
export const GET_FOLLOWING_STATUS = "followingStatus";
export const FOLLOW_UNFOLLOW = "followUnfollowAction";
export const FORUM_SEARCH = "forumSearch";


export const UPDATE_SELECTED_CATEGORY = "updateSelectedCategory";
export const CLEAR_SELECTED_CATEGORIES = "clearSelectedCategories";
export const CLEAR_SELECTED_CATEGORIES_ACTION = "clearSelectedCategories";
export const GET_COMMITTEES = "committees";
export const GET_COMMITTEE_NAMES = "getCommitteeNames";
export const ADD_COMMITTEE = "addCommittee";
export const GET_MEMBERS = "getMembers";
export const GET_EVENTS = "getEvents";
export const ADD_EVENT = "addEvent";
export const DELETE_EVENT = "deleteEvent";
export const UPDATE_EVENT = "updateEvent";
/**
 * Publication action
 */
export const GET_PUBLICATION_CATEGORY = "getPublicationCategory";
//export const GET_USER_SUBSCRIPTION = "getUserSubscription";
export const GET_RECENT_PUBLICATIONS = "getRecentPublications";
export const GET_PUBLICATION_CATEGORIES = "getPublicationCategories";
export const GET_PUBLICATION_SUBFOLDERS = "getPublicationSubfolders";
export const GET_SUBCAT_PUBLICATIONS = "getSubCategoryPublications";
export const CLEAR_PUBLICATIONS ="clearPublications";
export const CLEAR_SELECTED_PUBLICATIONS = "clearSelectedPublications";
export const DOWNLOAD_PUBLICATION = "downloadPublication";
export const PREVIEW_PUBLICATION = "previewPublication";
export const DOWNLOAD_BULK_PUBLICATION = "downloadBulkPublication";
export const UPDATE_SELECTED_PUBLICATIONS = "updateSelectedPublications";
export const GET_ALL_PUBLICATION_CATEGORIES = "getAllPublicationCategories";
/**
 * Subscription action
 */
export const GET_SUBSCRIPTION_CATEGORY = "getSubscriptionCategory";
export const SET_SUBSCRIPTION_FOLDER = "setSubscriptionFolder";
export const SET_CATEGORY_FOLDER = "setCategoryFolder";
export const CLEAR_CATEGORY_FOLDER = "clearCategoryFolder";
export const CLEAR_SUBCATEGORY_FOLDER = "clearSubcategoryFolder";
export const SET_SUBCATEGORY_PUBLICATION = "setSubCategoryPublication";
export const ADD_PUBLICATION_SUBSCRIPTION = "addPublicationSubscription";
export const DELETE_PUBLICATION_SUBSCRIPTION = "removePublicationSubscription";
export const ADD_PUBLICATION_NOTIFICATION = "addPublicationNotification";
export const DELETE_PUBLICATION_NOTIFICATION = "removePublicationNotification";
export const CLEAR_SUBSCRIPTION_PUBLICATIONS = "clearSubscriptionPublications";

/**
 * Notification action
 */
export const GET_USER_NOTIFICATION = "getUserNotification";
export const UPDATE_NOTIFICATION = "upNotification";

/**
 * Last used TA report
 */
 export const LAST_USED_TA_REPORT = "lastUsedTAReport";
 /**
 * CAC Acknowledge TA report
 */
  export const CAC_ACKNOWLEDGE_TA_REPORT = "lcacAcknowledgeTAReport";
